<template>
    <section>

        <div class="columns">
            <div class="column">
                
                <div class="field">
                  <label class="label has-text-left">Aesthetic</label>
                  <div class="field has-addons">
                      <div class="control is-expanded">
                        <div class="select is-fullwidth">
                          <select v-model="iotn.aesthetic">
                            <option v-for="(aesthetic_option, aesthetic_option_index) in aesthetic_options" v-bind:value="{ id: aesthetic_option.value, text: aesthetic_option.text }" :key="'aesthetic_' + aesthetic_option_index">{{ aesthetic_option.text }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="control">
                          <button class="button is-primary" @click="showAestheticOptionsModal = true">Show aesthetic options</button>
                      </div>
                  </div>
                </div>

                <aesthetic-options :show.sync="showAestheticOptionsModal" :aesthetic_option.sync="iotn.aesthetic"/>

                <article class="message is-info">
                <div class="message-header" @click="showAbbrevations = !showAbbrevations" style="cursor: pointer;">
                    <p>Abbrevations</p> <i class="fas fa-chevron-down" v-if="showAbbrevations == false"></i><i class="fas fa-chevron-up" v-if="showAbbrevations"></i>
                </div>
                <div class="message-body" v-if="showAbbrevations">
                    
                    <table class="table is-fullwidth is-striped is-hoverable">
                    <thead>
                        <tr>
                            <th><abbr title="Letter">Letter</abbr></th>
                            <th><abbr title="Description">Description</abbr></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>a</td>
                            <td>Overjet - recorded  to the most prominent  part of the prominent incisor</td>
                        </tr>
                        <tr>
                            <td>b</td>
                            <td>Reverse overjet without masticatory or speech problems</td>
                        </tr>
                        <tr>
                            <td>c</td>
                            <td>Crossbite</td>
                        </tr>
                        <tr>
                            <td>d</td>
                            <td>Displacement of contact points where teeth deviate from the line of the arch, worst displacement recorded spacing inline of the arch not included</td>
                        </tr>
                        <tr>
                            <td>e</td>
                            <td>Open bite</td>
                        </tr>
                        <tr>
                            <td>f</td>
                            <td>Deep bite</td>
                        </tr>
                        <tr>
                            <td>g</td>
                            <td>Good occlusion (Other)</td>
                        </tr>
                        <tr>
                            <td>h</td>
                            <td>Hypodontia</td>
                        </tr>
                        <tr>
                            <td>i</td>
                            <td>Impacted due to lack of space  ≥ 4mm</td>
                        </tr>
                        <tr>
                            <td>l</td>
                            <td>Posterior lingual crossbite</td>
                        </tr>
                        <tr>
                            <td>m</td>
                            <td>Reverse overjet with masticatory or speech problems</td>
                        </tr>
                        <tr>
                            <td>p</td>
                            <td>Defects of the cleft lip and palate</td>
                        </tr>
                        <tr>
                            <td>s</td>
                            <td>Submerged deciduous teeth</td>
                        </tr>
                        <tr>
                            <td>t</td>
                            <td>Partially erupted teeth, tipped and impacted against adjacent teeth</td>
                        </tr>
                        <tr>
                            <td>x</td>
                            <td>Presence of supernumerary teeth</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                </article>


                <div class="field">
                  <label class="label has-text-left">Missing</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="iotn.missing">
                        <option v-for="(missing_option, missing_option_index) in missing_options" v-bind:value="{ id: missing_option.value, text: missing_option.text }" :key="'missing_' + missing_option_index">{{ missing_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Overjet</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="iotn.overjet">
                        <option v-for="(overjet_option, overjet_option_index) in overjet_options" v-bind:value="{ id: overjet_option.value, text: overjet_option.text }" :key="'overjet_' + overjet_option_index">{{ overjet_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Crossbite</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="iotn.crossbite">
                        <option v-for="(crossbite_option, crossbite_option_index) in crossbite_options" v-bind:value="{ id: crossbite_option.value, text: crossbite_option.text }" :key="'crossbite_' + crossbite_option_index">{{ crossbite_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Displacement</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="iotn.displacement">
                        <option v-for="(displacement_option, displacement_option_index) in displacement_options" v-bind:value="{ id: displacement_option.value, text: displacement_option.text }" :key="'displacement_' + displacement_option_index">{{ displacement_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Overbite (including open bite)</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="iotn.overbite_incl_open_bite">
                        <option v-for="(overbite_incl_open_bite_option, overbite_incl_open_bite_option_index) in overbite_incl_open_bite_options" v-bind:value="{ id: overbite_incl_open_bite_option.value, text: overbite_incl_open_bite_option.text }" :key="'overbite_incl_open_bite_' + overbite_incl_open_bite_option_index">{{ overbite_incl_open_bite_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Other</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="iotn.other">
                        <option v-for="(other_option, other_option_index) in other_options" v-bind:value="{ id: other_option.value, text: other_option.text }" :key="'other_' + other_option_index">{{ other_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

            </div>
            <div class="column">
                <table class="table is-fullwidth is-striped is-hoverable" ref="iotnScoreTable">
                    <thead>
                        <tr>
                            <th><abbr title="Component">Component</abbr></th>
                            <th><abbr title="Description">Description</abbr></th>
                            <th><abbr title="Score">Score</abbr></th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th><abbr title="Total score">Total score </abbr></th>
                            <th><a class="button" @click="copy"><span class="iotn is-small"><i class="fas fa-copy"></i></span><span>Copy</span></a></th>
                            <th><abbr title="Score"><span class="is-size-1"> {{ calculateIotn }} </span></abbr></th>
                        </tr>
                    </tfoot>
                    <tbody>
                        <tr>
                            <td>Aesthetic</td>
                            <td>{{ this.iotn.aesthetic.text }}</td>
                            <td>{{ this.iotn.aesthetic.id }}</td>
                        </tr>
                        <tr>
                            <td>Missing</td>
                            <td>{{ this.iotn.missing.text }}</td>
                            <td>{{ this.iotn.missing.id }}</td>
                        </tr>
                        <tr>
                            <td>Overjet</td>
                            <td>{{ this.iotn.overjet.text }}</td>
                            <td>{{ this.iotn.overjet.id }}</td>
                        </tr>
                        <tr>
                            <td>Crossbite</td>
                            <td>{{ this.iotn.crossbite.text }}</td>
                            <td>{{ this.iotn.crossbite.id }}</td>
                        </tr>
                        <tr>
                            <td>Displacement</td>
                            <td>{{ this.iotn.displacement.text }}</td>
                            <td>{{ this.iotn.displacement.id }}</td>
                        </tr>
                        <tr>
                            <td>Overbite (including open bite)</td>
                            <td>{{ this.iotn.overbite_incl_open_bite.text }}</td>
                            <td>{{ this.iotn.overbite_incl_open_bite.id }}</td>
                        </tr>
                        <tr>
                            <td>Other</td>
                            <td>{{ this.iotn.other.text }}</td>
                            <td>{{ this.iotn.other.id }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script>

import AestheticOptions from './AestheticOptions.vue'

export default {
  name: 'iotn',
  components: {
      AestheticOptions
  },
  data: function() {
      return {
          iotn: {
              aesthetic: {id: '', text: ''},
              missing: {id: '', text: ''},
              overjet: {id: '', text: ''},
              crossbite: {id: '', text: ''},
              displacement: {id: '', text: ''},
              overbite_incl_open_bite: {id: '', text: ''},
              other: {id: '', text: ''}
          },
          aesthetic_options: [
              { text: '', value: '', key: 'aesthetic_1' },
              { text: 1, value: 1, key: 'aesthetic_2' },
              { text: 2, value: 2, key: 'aesthetic_3' },
              { text: 3, value: 3, key: 'aesthetic_4' },
              { text: 4, value: 4, key: 'aesthetic_5' },
              { text: 5, value: 5, key: 'aesthetic_6' },
              { text: 6, value: 6, key: 'aesthetic_7' },
              { text: 7, value: 7, key: 'aesthetic_8' },
              { text: 8, value: 8, key: 'aesthetic_9' },
              { text: 9, value: 9, key: 'aesthetic_10' },
              { text: 10, value: 10, key: 'aesthetic_11' }
          ],
          missing_options: [
            { text: '', value: '' },
            { text: '5.h - Extensive hypodontia with restorative impact (more than 1 congenitally missing tooth in any quadrant) requiring prerestorative orthodontics', value: '5' },
            { text: '5.s - Retained deciduous teeth', value: '5' },
            { text: '5.i - Impeded tooth eruption (3rd molars) attributable to crowding, displacements, supernumerary teeth, retained deciduous teeth and all pathological reasons', value: '5' },
            { text: '4.h - Less severe hypodontia requiring prerestorative orthodontics or orthodontic space closure to obviate the need for prosthetic restoration', value: '4' }
          ],
          overjet_options: [
            { text: '', value: '' },
            { text: '5.a - Overjet > 9 mm', value: '5' },
            { text: '5.m - Reverse overjet > 3.5 mm with masticatory and speech difficulties', value: '5' },
            { text: '4.a - Overjet 6.1-9 mm', value: '4' },
            { text: '4.b - Reverse overjet > 3.5 mm (without masticatory or speech problems)', value: '4' },
            { text: '4.m - Reverse overjet > 1 mm and ≤ 3.5 mm (with masticatory or speech problems)', value: '4' },
            { text: '3.a - Overjet 3.6-6 mm + incompetent lip closing', value: '3' },
            { text: '3.b - Reverse overjet 1.1 - 3.5 mm', value: '3' },
            { text: '2.a - Overjet - 3.5 - 6 mm + competent lip closing', value: '2' },
            { text: '2.b - Reverse overjet 0.1 - 1 mm', value: '2' }
          ],
          crossbite_options: [
            { text: '', value: '' },
            { text: '4.l - Posterior lingual crossbite with no functional occlusal contact in one or both buccal segments', value: '4' },
            { text: '4.c - Anterior or posterior crossbite with > 2 mm discrepancy between RCP and ICP', value: '4' },
            { text: '3.c - Anterior or posterior crossbite with 1.1 - 2 mm discrepancy between RCP and ICP', value: '3' },
            { text: '2.c - Anterior or posterior crossbite with 1 mm discrepancy between RCP and ICP', value: '2' }
          ],
          displacement_options: [
            { text: '', value: '' },
            { text: '4.d - Contact point displacement > 4 mm', value: '4' },
            { text: '4.t - Partially erupted teeth, tipped and impacted against adjacent teeth', value: '4' },
            { text: '4.x - Existence of supernumerary teeth', value: '4' },
            { text: '3.d - Contact point displacement 2.1 - 4 mm', value: '3' },
            { text: '2.d - Contact point displacement 1.1 - 2 mm', value: '2' },
            { text: '1. Extremely minor malocclusion with contact point displacements of less than 1 mm', value: '1' }
          ],
          overbite_incl_open_bite_options: [
            { text: '', value: '' },
            { text: '4.e - Anterior or posterior open bite > 4 mm', value: '4' },
            { text: '4.f - Increased & complete overbite with gingival or palatal trauma', value: '4' },
            { text: '3.e - Anterior or posterior open bite 2.1 - 4 mm', value: '3' },
            { text: '3.f - Deep overbite with gingival contact or contact with palatal mucosa (but without trauma)', value: '3' },
            { text: '2.e - Anterior or posterior open bite 1.1 - 2 mm', value: '2' },
            { text: '2.f - Increased overbite > 3.5 mm without gingival contact', value: '2' }
          ],
          other_options: [
            { text: '', value: '' },
            { text: '5.p - Cleft lip and palate and other craniofacial anomalies', value: '5' },
            { text: '2.g - Class II or class III occlusion without other anomalies (up to half a premolar width)', value: '2' }
          ],
          showAestheticOptionsModal: false,
          showAbbrevations: false
      }
  },
  methods: {
      copy() {
          var t = 'Aesthetic: ' + this.iotn.aesthetic.text + ', score: ' + this.iotn.aesthetic.id
          t += '\nMissing: ' + this.iotn.missing.text + ', score: ' + this.iotn.missing.id
          t += '\nOverjet: ' + this.iotn.overjet.text + ', score: ' + this.iotn.overjet.id
          t += '\nCross bite: ' + this.iotn.cross_bite.text + ', score: ' + this.iotn.cross_bite.id
          t += '\nDisplacement: ' + this.iotn.displacement.text + ', score: ' + this.iotn.displacement.id
          t += '\nOverbite (including open bite): ' + this.iotn.overbite_incl_open_bite.text + ', score: ' + this.iotn.overbite_incl_open_bite.id
          t += '\nOther: ' + this.iotn.other.text + ', score: ' + this.iotn.other.id
          t += '\n\nTotal score according to iotn: ' + this.calculateIotn
          this.$copyText(t)
      }
  },
  computed: {
      calculateIotn() {
          return null;
      }
  },
  mounted() {
  }
}
</script>
